import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import OtpInput from 'react-otp-input';
import { AuthContext } from "./../../context/auth";
import { withSnackbar } from 'react-simple-snackbar';

class LoginOtpComponent extends Component{
    static contextType = AuthContext;

    state = {
        otp : ''
    }

    handleCancel = () => {
        this.props.history.push(process.env.PUBLIC_URL+'/')
    }

    handleChange = otp => {
        this.setState({ otp });
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        if(this.props.location.state.otp !== this.state.otp)
            this.props.openSnackbar('Otp does not match.')
        else
            this.props.history.push({ pathname: process.env.PUBLIC_URL+'/signup', state: { phone: this.props.location.state.phone_number }});

    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='login-otp'
    }

    componentWillUnmount() {
        document.getElementById('body').className=''
    }

    render(){
        const phone_number = this.props.location.state.phone_number;
        return (
            typeof this.props.location.state!='undefined' && !this.context.authenticated ?
            <React.Fragment>
                <div className="login--bgmain">
                </div>
                <div className="choose-deals-outer login-otp-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10 col-lg-5 mx-auto">
                            <form autoComplete="off" onSubmit={this.handleFormSubmit} className="forgotpswd-form digit-group">
                                <h4 className="text-white text-center d-block green-color font-weight-bold">OTP</h4>
                                <div className="forgotpswd-outer text-center p-0">
                                    <label className="forgotpswd-label">Enter the 4 - digit code sent to you
                                        at <span>+</span>*********{phone_number.substring(phone_number.length - 3, phone_number.length)}</label>
                                    <OtpInput
                                        containerStyle="otpfield-outer"
                                        inputStyle="otp--field"
                                        onChange={this.handleChange}
                                        numInputs={4}
                                        shouldAutoFocus={true}
                                        value={this.state.otp}
                                        isInputNum={true}
                                    />
                                    <div className="btn-rowstack d-none">
                                        <button className="cancel-btn" type="button" onClick={this.handleCancel}>Cancel</button>
                                        <button className="entry-btn cancel-btn grad-on" type="submit">Submit</button>
                                    </div>
                                    <div className="count-down d-flex justify-content-between align-items-center mt-4">
                                        <div className="resend-code">

                                        </div>
                                        <div className="resend-timer d-flex align-items-center">
                                            <button className="entry-btn grad-on" type="submit"><img
                                                src={`${process.env.PUBLIC_URL}/image/back_white.png`} alt=""/></button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>
            </React.Fragment> :
            <Redirect to={{ pathname: process.env.PUBLIC_URL+'/', state: { from: this.props.location } }} />
        )
    }
}

export default withSnackbar(LoginOtpComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});